import { useStatsigClient } from '@statsig/react-bindings'

/**
 * Whether Statsig has finished initializing.
 *
 * `FunkitStatsigProvider` renders its children while `initializeAsync` is still
 * running, so every config read before that answers from the bootstrap fallback
 * baked in at build time. That is the right default for reads that only tune
 * behaviour, and the wrong one for a read that decides whether a buyer may
 * proceed — those must wait for the remote value.
 */
export function useStatsigReady(): boolean {
  return !useStatsigClient().isLoading
}
